import React, {useState} from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Image from "react-bootstrap/Image";
import { resolveImageUrl, resolveSwatchUrl } from '../../utils/imageUrl';

const NewHireKitItem = ({ item, inventory, setSize, remove, edit, currentSize, clearErrors }) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

  const sizeChange = (e) => {
    setSize(item.nhkiId, e.target.value);
    clearErrors();
  }


  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }


  return (
    <Container className="mt-5" style={{ border: "1px solid #CCCCCC", padding: 10 }}>
     <Row>
        <Col sm={2}>
          <div style={{ display: "inline-block", position: "relative" }}>

            <Image className="modelImageImg" src={resolveImageUrl(item.frontModelImage)} fluid ></Image>

            {item.logos.filter(logo => logo.x != null && logo.y != null && logo.width != null).map((logo, i) => (
              <img key={i} className="logo-image" src={apiUrl + logo.decoration_logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
            )
            )}


          </div>
        </Col>
        <Col sm={10}>
          <div style={{ position: "relative" }}>
            <div className="title">{item.title}</div>
            <div className="color-title">
              Color: {item.colorName}

              {item.hexColor && item.hexColor != "" && !(item.squareImageName && item.squareImageName != "") && (
                <div style={{ marginLeft: 10, display: "inline-block", backgroundColor: item.hexColor, width: 20, height: 20 }}></div>
              )}
              {item.squareImageName && item.squareImageName != "" && (
                <img src={resolveSwatchUrl(item.squareImageName)} height={18} />
              )}


            </div>            <div className="color-title">
              Decorations:
              <div style={{ padding: 5, marginLeft: 20 }}>
                {item.logos.map((logo, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
                    <span style={{ fontWeight: 'bold', minWidth: 120 }}>
                      {logo.deco_location?.description || 'Unknown Location'}:
                    </span>
                    <span style={{ marginLeft: 10 }}>
                      {logo.decoration_logo.decorationName} ({logo.decoration_logo.decoType})
                    </span>
                  </div>
                ))}
              </div>

            </div>
            <div>
              <Form.Group className="mb-3" controlId="state">
                {edit && (
                <select
                  name="size"
                  onChange={(e) => {
                    sizeChange(e);
                  }}
                >
                  <option value="">Select a Size</option>
                  {item.sizes.map(size => {
                    var inv = inventory.find(item => item.uniqueKey == size.uniqueKey);
                    if (!inv || (inv && inv.quantity == 0)) {
                      return (
                        <option value={size.productId} disabled>{formatPantsSize(size.sizeName)}</option>
                      );
                    } else {
                      if (inv && inv.quantity < 30) {
                        return (
                          <option value={size.productId}>{formatPantsSize(size.sizeName) + "Low Stock: " + inv.quantity}</option>

                        );

                      } else {

                        return (
                          <option value={size.productId}>{formatPantsSize(size.sizeName)}</option>
                        );
                      }
                    }

                  })}



                </select>)}
                {!edit && (
                  <div>Size: {currentSize}</div>
                )}
              </Form.Group>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NewHireKitItem;